import { io } from 'socket.io-client';
import { API_BASE_URL } from '../config/api';

let socket = null;

/** Shared Socket.IO connection (one per browser tab). */
export function getLiveSocket() {
  if (!socket) {
    socket = io(API_BASE_URL, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 2000
    });
  }
  return socket;
}

/**
 * Announce the logged-in user to the server so presence tracking starts.
 * Re-announces on every (re)connect. Skipped while a principal is impersonating.
 */
let presenceUser = null;
let presenceBound = false;
export function announcePresence(user) {
  const s = getLiveSocket();
  const uid = user && (user._id || user.id);
  presenceUser = uid ? { userId: String(uid), role: user.role } : null;
  s.auth = presenceUser || {};
  if (!presenceBound) {
    presenceBound = true;
    s.on('connect', () => {
      if (presenceUser) s.emit('register_active_user', presenceUser);
    });
  }
  if (s.connected && presenceUser) s.emit('register_active_user', presenceUser);
}

/** Window event used by toasts/banners to ask the hub to open the viewer. */
export const OPEN_LIVE_VIEWER_EVENT = 'open-live-viewer';
